import {
  ADD_PARTNER_HOST_LOADING,
  ADD_PARTNER_HOST_SUCCESS,
  ADD_PARTNER_HOST_FAILED,
} from "../types";

const initialState = {
  add_loading: false,
  add_data: null,
  add_error: null,
};

type Action = {
  type: string;
  loading?: boolean;
  payload?: any;
  error?: any;
};

const addPartnerHostReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case ADD_PARTNER_HOST_LOADING:
      return {
        ...state,
        add_loading: action.loading,
      };
    case ADD_PARTNER_HOST_SUCCESS:
      return {
        ...state,
        add_data: action.payload,
        add_error: null,
      };
    case ADD_PARTNER_HOST_FAILED:
      return {
        ...state,
        add_error: action.error,
        add_data: null,
      };
    default:
      return state;
  }
};

export default addPartnerHostReducer;
